import { extractFirstAndLastName } from './BadgeUtils';

// Layout HORIZONTAL do crachá (8.6cm x 5.4cm — padrão CR-80).
// Mantido em arquivo separado do layout vertical (BadgeUtils.js) para que a
// diretoria possa comparar/aprovar os dois modelos antes de descartar qualquer um.
export const generateBadgeCardHorizontal = async (user) => {
    const { firstName, lastName } = extractFirstAndLastName(user.User.nome);
    const mainNameFinal = user.nome_cracha || (firstName + ' ' + lastName);
    const voluntarioId = user.codigo_antigo_voluntariado || user.codigo_voluntario_feesp || '00000000';

    const userPhoto = user.foto_cracha || user.User?.imagem_perfil;
    let userPhotoUrl = null;
    if (userPhoto instanceof File) {
        userPhotoUrl = URL.createObjectURL(userPhoto);
    } else if (userPhoto) {
        userPhotoUrl = `${process.env.REACT_APP_API_KEY}/images/${userPhoto}`;
    }

    const card = document.createElement('div');
    card.style.width = '8.6cm';
    card.style.height = '5.4cm';
    card.style.backgroundImage = `url(/images/fundo-cracha.jpg)`;
    card.style.backgroundSize = '100% 100%';
    card.style.backgroundPosition = 'center';
    card.style.backgroundRepeat = 'no-repeat';
    card.style.position = 'relative';
    card.style.fontFamily = "'DIN 2014', 'Arial Narrow', 'Roboto', sans-serif";
    card.style.color = '#000';
    card.style.overflow = 'hidden';
    card.style.boxShadow = '0 0 1px rgba(0,0,0,0.1)';
    card.style.borderRadius = '20px';

    card.innerHTML = `
        <div style="
            position: absolute;
            top: 1.44cm;
            left: 0.76cm;
            width: 2.47cm;
            height: 2.21cm;
            border-radius: 14px;
            overflow: hidden;
            background-color: white;
            z-index: 2;
            ${userPhotoUrl ? `background-image: url('${userPhotoUrl}'); background-size: cover; background-position: center; background-repeat: no-repeat;` : ''}
        " class="badge-photo-container">
            <div class="badge-photo-overlay" style="
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 35%;
                background-color: rgba(0, 0, 0, 0.25);
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                border-bottom-left-radius: 20px;
                border-bottom-right-radius: 20px;
                transition: all 0.3s ease;
            ">
                <div class="badge-action-buttons" style="
                    display: flex;
                    gap: 4px;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 0 4px;
                ">
                    <button type="button" class="badge-btn-change" style="
                        background: rgba(255, 255, 255, 0.95);
                        border: none;
                        border-radius: 4px;
                        padding: 3px 6px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 8px;
                        font-weight: 600;
                        color: #333;
                        transition: all 0.2s ease;
                        font-family: sans-serif;
                    " title="Escolher nova foto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" y1="3" x2="12" y2="15"></line>
                        </svg>
                        <span>Alterar</span>
                    </button>

                    <button type="button" class="badge-btn-crop" style="
                        background: rgba(255, 255, 255, 0.95);
                        border: none;
                        border-radius: 4px;
                        padding: 3px 6px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 8px;
                        font-weight: 600;
                        color: #333;
                        transition: all 0.2s ease;
                        font-family: sans-serif;
                    " title="Ajustar enquadramento">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <circle cx="8.5" cy="8.5" r="1.5"></circle>
                            <polyline points="21 15 16 10 5 21"></polyline>
                        </svg>
                        <span>Ajustar</span>
                    </button>
                </div>
            </div>
        </div>

        <div style="
            position: absolute;
            top: 1.8cm;
            left: 3.5cm;
            right: 0.5cm;
            line-height: 1.1;
            z-index: 2;
        ">
            <div style="
                font-size: 14pt;
                font-weight: 800;
                text-transform: uppercase;
                margin-bottom: 0.1cm;
            ">
                ${mainNameFinal}
            </div>

            <div style="
                font-size: 10pt;
                font-weight: 400;
            ">
                Código do Voluntário: ${voluntarioId}
            </div>
        </div>
    `;

    return card;
};
